export default{
   methods:{
      // 消息提示
      customMessageBox(message,type,userHtml,showClose,duration){
         const msgInfo = message;
         const msgType = type || "success";
         const msgUserHtml = userHtml || false;
         const msgShowClose = showClose || false;
         const msgDuration = duration || 2000;
         this.$message({
            center: true,
            title: this.$t("msgTitle"),
            type: msgType,  // 主题，success/warning/info/error
            message: msgInfo,  // 消息文字
            duration: msgDuration,  // 显示时间, 毫秒。设为 0 则不会自动关闭
            showClose: msgShowClose,  // 是否显示关闭按钮
            dangerouslyUseHTMLString: msgUserHtml,  // 是否将 message 属性作为 HTML 片段处理
            offset: (document.body.clientHeight/2),  // Message 距离窗口顶部的偏移量
         });
      },
      // 确认提示框
      confirmMessageBox(message,title,confirType,msgUserHtml){
         return new Promise((resolve,reject) => {
            this.$confirm(message, title || this.$t("msgTitle"), {
               confirmButtonText: this.$t("msgSureBtn"),
               cancelButtonText: this.$t("msgCancelBtn"),
               dangerouslyUseHTMLString: msgUserHtml || false,
               type: confirType || 'warning'
            }).then(() => {
               resolve
            }).catch(() => {

            })
         })
      }
   }
}


// WEBPACK FOOTER //
// ./src/mixins/message.js